import { useMutation } from 'react-query'
import { getTheNightlyUpdateNameActionPath } from '@news-mono/web-common'

export interface ChangeNameFormData {
    firstName: string
    lastName: string
}

interface ChangeNameRequest extends ChangeNameFormData {
    userId: string
    onError?: (data: any) => void
    onSuccess?: (data: any) => void
}

export const useChangeName = ({
    firstName,
    lastName,
    userId,
    onError,
    onSuccess,
}: ChangeNameRequest) => {
    const request = 'change-name-request'

    return useMutation(
        request,
        async () => {
            const response = await fetch(getTheNightlyUpdateNameActionPath, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userId,
                    given_name: firstName,
                    family_name: lastName,
                }),
            })

            if (!response.ok || response.status !== 201) {
                if (onError) {
                    throw response
                }
                return false
            }
            return true
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        },
    )
}

interface ValidateNameResult {
    valid: boolean
    message?: string
}

export const validateName = ({
    firstName,
    lastName,
}: ChangeNameFormData): ValidateNameResult => {
    if (!firstName || !lastName) {
        return {
            valid: false,
            message: 'Both first name and last name are required',
        }
    }

    if (firstName.length > 50 || lastName.length > 50) {
        return {
            valid: false,
            message:
                'First name and last name should be less than 50 characters',
        }
    }

    return { valid: true }
}
